module.exports = __webpack_public_path__ + "img/Colorize03.d74de496.png";